import { useTranslation } from 'react-i18next'
import { TableButton } from '@features/admin/features/approval-domain-approvers'

export const LinkedButton = ({
  linked,
  onLink,
  onUnlink,
}: {
  linked: boolean
  onLink: () => void
  onUnlink: () => void
}) => {
  const { t } = useTranslation()
  
  return (
    <TableButton
      onClick={() => (linked ? onUnlink() : onLink())}
      variant={linked ? 'danger' : 'primary'}
    >
      {linked ? t('common.unlink') : t('common.link')}
    </TableButton>
  )
}
